import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  CustomInput,
  Label
} from "reactstrap";
import NumberFormat from 'react-number-format';
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import ReactSelect from "../../../components/Form/Select/Select"
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'
import './style.css'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FromCategoria = ({ fechaModal, filial_id, categoria_id}) => {
  //valores iniciais do formulario
  const inicialForm = {
    categoria_id: '',
    categoria: '',
    comissao_id: '',
    comissao: '',
    comissaoSelect: '',
    desconto: '0.00',
    tipo: '',
    fidelidade: 'N',
    filial_id: filial_id
  }

  const [form, onChange, setForm, onChangeSelect] = useForm(inicialForm)
  const [listaComissao, setListaComissao]         = useState([]);
  const [loading, setLoading]                     = useState(true);

  // Lista comissao select
  const listaComissoes = () => {
    let comissoes = []
    try{
      const retorno = rest.get(rotas.comissao)
      retorno.then(ret => {
        if (ret.success && ret.success === 'S' && ret.lista !== ''){
          comissoes = ret.lista
          for (let i = 0; i < comissoes.length; i++) {
            comissoes[i].id     = comissoes[i].padrao_comissao_id
            comissoes[i].title  = comissoes[i].padrao_comissao+" %"

            if (comissoes[i].desconto){
              comissoes[i].desconto = '0'
            }
          }

          setListaComissao(comissoes)
        }
      })
      return (true)
    }catch(err){
      return (false)
    }
  }

  //preenche setform e formulario
  const listaCategoria = (filial_id, categoria_id) => {
    // console.log(categoria_id)
    const retorno = rest.get(rotas.categoria+filial_id+'/'+categoria_id)
    retorno.then(ret => {
      // console.log(ret)
      if (ret.success && ret.success === 'S') {
        ret.lista[0].comissaoSelect = {"id":ret.lista[0].comissao_id, "title": ret.lista[0].comissao ? ret.lista[0].comissao+" %" : ''}
        setForm(ret.lista[0])
        setLoading(false)
      }
    })
  }

  useEffect(() => {

    if (listaComissoes()) {
      if(categoria_id !== ''){
        listaCategoria(filial_id, categoria_id)
      }else{
        setForm(inicialForm)
        setLoading(false)
      }
    }
  },[]) // eslint-disable-line react-hooks/exhaustive-deps

  const verificaDescontoMaximo = ()=>{
    if(form.desconto_maximo != ""){
      Swal.fire({
        title: 'Gostaria de atribuir o desconto máximo aos produtos cadastrados para esta categoria?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        denyButtonText: 'Não',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          form.atualizar_desconto_maximo = 'S';
        } else {
          form.atualizar_desconto_maximo = 'N';
        }
      })
    }
  }

  const verificaPadraoComissao = ()=>{
 
    Swal.fire({
      title: 'Gostaria de atribuir esse padrão de comissão aos produtos cadastrados para esta categoria?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sim',
      denyButtonText: 'Não',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        form.atualizar_padrao_comissao = 'S';
      } else {
        form.atualizar_padrao_comissao = 'N';
      }
    })
    
  }


  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        // return formSwal.insertQueueStep('teste')
        const url = rotas.categoria+'gravar.php'
        if(categoria_id !== ''){
          return rest.post(url, form)
            .then(ret => {
              // console.log(ret)
              if (ret.success === 'S') {
                if((form.atualizar_desconto_maximo === 'S')||(form.atualizar_padrao_comissao === 'S')){
                  if(ret.retorno_produtos === 'Sucesso'){
                    formSwal.fire('Salvo!',
                                ret.msg,
                                'success')
                  }else{
                    formSwal.fire('Atenção',
                                'Problemas na atualização do desconto máximo / padrão comissão',
                                'warning')
                  }
                }else{
                  formSwal.fire('Salvo!',
                                ret.msg,
                                'success')
                }
              
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
            })
        }else{
          return rest.put(url, form)
            .then(ret => {
              if (ret.success === 'S') {
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
            })
        }

      }
    }])

  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return(
      <>
      <FormGroup className ="formCadastro">
        <ModalBody className ="pb-0">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md ='6'>
                <Row>
                  <Col md ='4'>
                    <FormGroup>
                      <Label for ="categoria_id">Código</Label>
                      <Input
                        disabled
                        style     = {{background: '#F9F9F9'}}
                        name      = "categoria_id"
                        id        = "categoria_id"
                        value     = {form.categoria_id}
                        onChange  = {onChange('categoria')}
                      />
                    </FormGroup>
                  </Col>
                  <Col md ='8'>
                    <FormGroup>
                      <Label for ="categoria">Categoria</Label>
                      <Input
                        required
                        name      = "categoria"
                        id        = "categoria"
                        value     = {form.categoria}
                        onChange  = {onChange('categoria')}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup>
                  <ReactSelect
                    required
                    name          = "comisao"
                    label         = "Comissão"
                    placeholder   = "Selecione"
                    options       = {listaComissao}
                    defaultValue  = {form.comissaoSelect}
                    onChange      = {onChangeSelect('comissaoSelect')}
                    onClick       = {form.comissao_id = form.comissaoSelect.id}
                    onBlur        = {()=>{verificaPadraoComissao()}}
                  >
                  </ReactSelect>
                </FormGroup>

                <FormGroup>
                  <Label for = "desconto">Desc. Máximo</Label>
                  <NumberFormat
                    // required
                    id                = "desconto"
                    name              = "desconto"
                    placeholder       = "0,00%"
                    value             = {form.desconto.replace('.', ',')}
                    onChange          = {onChange('desconto')}
                    maxLength         = {20}
                    decimalScale      = {2}
                    allowNegative     = {false}
                    className         = {"form-control"}
                    suffix            = {"%"}
                    decimalSeparator  = {','}
                    fixedDecimalScale
                    onBlur            = {()=>{verificaDescontoMaximo()}}
                  />
                </FormGroup>
              </Col>

              <Col md='6'>
                <Col md='12' className="card-2">
                  <FormGroup>
                    <span className="tag-card">Tipo</span>
                    <div>
                      <CustomInput
                        type      = "radio"
                        id        = "tipoMedicamento"
                        name      = "tipo"
                        value     = "M"
                        label     = "Medicamento"
                        checked   = {form.tipo==='M' ? true : false}
                        onClick   = {onChange('tipo')}
                        onChange  = {onChange('tipo')}
                      />
                      <CustomInput
                        type      = "radio"
                        id        = "tipoPerfumaria"
                        name      = "tipo"
                        value     = "P"
                        label     = "Perfumaria"
                        checked   = {form.tipo==='P' ? true : false}
                        onClick   = {onChange('tipo')}
                        onChange  = {onChange('tipo')}
                      />
                      <CustomInput
                        type      = "radio"
                        id        = "tipoOutros"
                        name      = "tipo"
                        value     = "O"
                        label     = "Outros"
                        checked   = {form.tipo==='O' ? true : false}
                        onClick   = {onChange('tipo')}
                        onChange  = {onChange('tipo')}
                      />
                    </div>
                  </FormGroup>
                </Col>

                <Col md='12' className="card-2">
                  <FormGroup className="mb-0">
                    <span className="tag-card">Fidelidade</span>
                    <div>
                      <CustomInput
                        type      = "checkbox"
                        id        = "fidelidade"
                        name      = "fidelidade"
                        label     = "Geram pontos no programa fidelidade"
                        checked   = {form.fidelidade==='S' ? true : false}
                        //onClick = {onChange('fidelidade')}
                        onChange  = {onChange('fidelidade')}
                      />
                    </div>
                  </FormGroup>
                </Col>
              </Col>
            </Row>

            <Col className="text-center p-3">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >
                Salvar
              </Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
                Fechar
              </Button>
            </Col>
          </Form>
        </ModalBody>
      </FormGroup>
      </>
    )
  }

}

export default FromCategoria
